<template>
  <keep-alive>
    <div class="wrap-action-list">
      <div class="response_table">
        <table>
          <thead
            ref="tableHead"
            class="table-action-list_bg"
          >
            <tr>
              <th
                  class="pointer name"
                  @click="change_filter('mno')"
                  :class="{ selected: filter_type === 'mno' }"
                  scope="col"
              >
                {{ translate('simcard_profile.traffic_list.mno') }}
                <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
              </th>

              <th
                  class="pointer name"
                  @click="change_filter('oper_account')"
                  :class="{ selected: filter_type === 'oper_account' }"
                  scope="col"
              >
                {{ translate('simcard_profile.traffic_list.oper_account') }}
                <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
              </th>

              <th
                  class="pointer name"
                  @click="change_filter('iccid')"
                  :class="{ selected: filter_type === 'iccid' }"
                  scope="col"
              >
                {{ translate('simcard_profile.traffic_list.iccid') }}
                <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
              </th>

              <th
                  class="pointer name"
                  @click="change_filter('sim_type')"
                  :class="{ selected: filter_type === 'sim_type' }"
                  scope="col"
              >
                {{ translate('simcard_profile.traffic_list.sim_type') }}
                <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
              </th>

              <th
                  class="pointer name"
                  @click="change_filter('status')"
                  :class="{ selected: filter_type === 'status' }"
                  scope="col"
              >
                {{ translate('simcard_profile.traffic_list.status') }}
                <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
              </th>

              <th
                  class="pointer name"
                  @click="change_filter('tariff_name')"
                  :class="{ selected: filter_type === 'tariff_name' }"
                  scope="col"
              >
                {{ translate('simcard_profile.traffic_list.tariff_name') }}
                <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
              </th>

              <th
                  class="pointer name"
                  @click="change_filter('traffic_rest')"
                  :class="{ selected: filter_type === 'traffic_rest' }"
                  scope="col"
              >
                {{ translate('simcard_profile.traffic_list.traffic_rest') }}
                <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
              </th>

              <th
                  class="pointer name"
                  @click="change_filter('ts_update')"
                  :class="{ selected: filter_type === 'ts_update' }"
                  scope="col"
              >
                {{ translate('simcard_profile.traffic_list.ts_update') }}
                <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
              </th>

            </tr>
          </thead>

          <tbody ref="tableSimcard">
            <tr v-if="load">
              <td> <scale-loader /> </td>
            </tr>
            <TrafficListItem
                v-for="(traffic, key) in traffic_list_comp"
                :key="key"
                :traffic_item="traffic"
            />
          </tbody>
        </table>
      </div>
    </div>
  </keep-alive>
</template>
<script>
import TrafficListItem from "./Item/TrafficListItem.vue";

export default {
  name: 'TrafficList',
  components: {
    TrafficListItem
  },
  data () {
    return {
      load: true,
      traffic_list: [],
      filter_asc: "asc",
      filter_type: "",
    }
  },

  computed:{
    traffic_list_comp(){
      let traffic_list_comp = [...this.traffic_list];
      return traffic_list_comp.sort(this.compareNumbers);
    },
  },

  created () {
    this.load_traffic_list()
  },

  methods: {
    load_traffic_list(){
      this.load = true
      this.$http.simcard.getSimcardProfileTraffic({}, (response) => {
        if (response.data){
          this.load = false
          this.traffic_list = response.data
        }else{
          this.global_notify('danger', this.translate('no_data'))
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>

.wrap-action-list{
  display: flex;
  flex-direction: column;
  height: 100%;
  .response_table{
    padding: 0;
    .action_item{
      cursor: pointer;
      &:hover{
        background-color: #eee;
      }
    }
  }
}

</style>
